import { CommandType } from "../../../../common/services/cqs/CommandType";
import { KontraktSkogsvardBetalning } from "../../models/skogsvard/skogsvard-models";
import { BetalningSkogsvardBaseCommand } from "./BetalningSkogsvardBaseCommand";

export class UpdateBetalningSkogsvardCommand extends BetalningSkogsvardBaseCommand {
    readonly apris?: number;
    readonly anteckningIntern: string;
    readonly rowVersion: string;
    readonly betalningstyp: string;
    readonly mattslag: string;
    readonly belopp?: number;
    readonly kvantitet?: number;
    readonly virkeskopsatgardId?: number;

    static readonly $type = "UpdateBetalningSkogsvardCommand";

    constructor(kontraktGuid: string, betalning: KontraktSkogsvardBetalning) {
        super(kontraktGuid, betalning.id, UpdateBetalningSkogsvardCommand.$type, CommandType.Replace);
        this.apris = betalning.apris;
        this.anteckningIntern = betalning.anteckningIntern;
        this.rowVersion = betalning.rowVersion;
        this.betalningstyp = betalning.betalningstyp;
        this.mattslag = betalning.mattslag;
        this.belopp = betalning.belopp;
        this.kvantitet = betalning.kvantitet;
        this.virkeskopsatgardId = betalning.virkeskopsatgardId;
    }
}
